<template>
    <div>
        <NavigationBar></NavigationBar>
        <UserMenu></UserMenu>
        <FilterUser></FilterUser>
        <UserList></UserList>
        <UserEdit></UserEdit>
        <UserDelete></UserDelete>
        <FooterView></FooterView>
    </div>
</template>
<script>
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import UserList from '@/components/UserMaintainer/User-list.vue'
import UserMenu from '@/components/UserMaintainer/User-menu.vue'
import UserEdit from '@/components/UserMaintainer/User-edit.vue'
import UserDelete from '@/components/UserMaintainer/User-delete.vue'
import FilterUser from '@/components/UserMaintainer/Filter-user.vue'
import FooterView from '@/components/shared/Footer/Footer-view.vue';

export default {
    name: 'UserMaintainerViews',

    components: {
        NavigationBar,
        UserList,
        UserMenu,
        UserEdit,
        UserDelete,
        FilterUser,
        FooterView
    }

}
</script>
<style></style>